import ApiBase from "./ApiBase";

export const uploadStoreMatrix = async (file, sendToAllocation, allocationName) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("sendToAllocation", sendToAllocation); // Add the sendToAllocation flag
  if (sendToAllocation) {
    formData.append("allocationName", allocationName); // Add allocation name if applicable
  }
  try {
    const response = await ApiBase.post("/import_store_matrix", formData);
    return response.data;
  } catch (error) {
    console.error(
      "Error uploading store matrix:",
      error.response?.data || error.message
    );
    throw error.response?.data || error;
  }
};

export const downloadTemplate = async (division) => {
  try {
    const response = await ApiBase.get("/import_store_matrix/download_template", {
      division,
      responseType: "blob",
    });

    return response;
  } catch (error) {
    console.error(
      "Error downloading store matrix template:",
      error.response?.data || error.message
    );
    throw error.response?.data || error;
  }
};

export const fetchImportedFiles = async () => {
  try {
    const response = await ApiBase.get("/import_store_matrix/imported_files");
    return response.data;
  } catch (error) {
    console.error("Error fetching imported files:", error.response?.data || error.message);
    throw error;
  }
};
